import React, {Tabs} from "antd";

export const TablesTabs = ({tables, onChange, selectedTab}) => {

    if (!tables || tables.length === 0) {
        return null;
    }

    let tabs = [
        {
            key: "results",
            label: "RESULTS"
        }
    ];

    tabs = tabs.concat(tables.map((table, index) => ({
        key: table.tableName,
        label: `PREVIEW:  ${table.tableName}`
    })));

    return <Tabs items={tabs} onChange={onChange} activeKey={selectedTab} />

}